import React, { useEffect, useContext, useState } from "react";
import CalendarDatePicker from "../../components/_default/Calendar";
import Appointment from "../../components/_default/Calendar/appointment";
import NavButton from "../../components/_default/NavButton";
import Profile from "../../components/_dashboard/profile";
import Graph from "../../components/_dashboard/graph";
import UserContext from "../../services/context/userContext";
import { getClients, getWorkoutsCoach, getCLientByName, getMealplanFromClient, getWorkoutFromClient } from "../../services/firebase/firestore/getData";
import DropDown from "../../components/_default/DropDown";
import { Link } from "react-router-dom";
import "./Dashboard.scss";
import { doSignOut } from "../../services/firebase/auth";
import Icon from "../../components/_default/Icon";
import CalendarItem from "../../components/_default/Calendar";
import TodoList from "../../components/_clients/Calendar/TodoList";


function Dashboard({ t }) {
  const [clientCount, setClientCount] = useState(false);
  const [workoutCount, setWorkoutCount] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filterName, setFilterName] = useState(false);
  const [client_name, setCLientName] = useState(false);
  const [clients, setClients] = useState(false);
  const user = useContext(UserContext);

  const [selectedClientId, setSelectedClientId] = useState(false);
  const [totalMeals, setTotalMeals] = useState(0);
  const [totalCalories, setTotalCalories] = useState(0);
  const [totalCaloriesDone, setTotalCaloriesDone] = useState(0);

  const [totalExercises, setTotalExercises] = useState(0);
  const [exercisesDone, setExercisesDone] = useState(0);
  const [totalExerciseTime, setTotalExerciseTime] = useState(0);



  function handleLogout() {
    doSignOut();
  }

  useEffect(() => {
    getClients(user.id, (result) => {
      setClientCount(result.length)
    });

    getClients(user.id, (result) => {
      if(result){
          let clientNames = [];
          let clients = [];
          result && result.forEach(element => {
              clientNames.push(element.first_name + " " + element.last_name);
              clients.push({
                name: element.first_name + " " + element.last_name,
                id: element.id
              })
          });
          setFilterName(clientNames);
          setCLientName(result[0].first_name + " " + result[0].last_name);
          setClients(clients);
      }
    });
  }, []);

  useEffect(() => {
    getWorkoutsCoach(user.id, (result) => {
      setWorkoutCount(result.length)
    });
  });

  var a = new Date();
  var year = a.getFullYear();
  var month = a.getMonth()+1;
  var day = a.getDate();
  
  if(month < 10) {
    month = "0" + month;    
  }
  if(day < 10) {
    day = "0" + day;
  }
  var time = year + "-" + month + "-" + day;
  var currentTime = year + "-" + month + "-" + day;
  var date = day + "/" + month + "/" + year;
  let longMonth = a.toLocaleString('en-us', { month: 'long' }); 
  const [fullTime, setFullTime] = useState(day + " " + longMonth + " " + year);
  let shortMonth = a.toLocaleString('en-us', { month: 'short' });
  const [shortFullTime, setShortFullTime] = useState(day + " " + shortMonth + " " + year);
  const [Time, setTime] = useState(time);

  function handleCalendarChange(newSelectedDate) {
    var timestamp = new Date(Date.parse(newSelectedDate));
    var year = timestamp.getFullYear();
    var month = timestamp.getMonth()+1;
    var day = timestamp.getDate();
    if(month < 10) {
      month = "0" + month;    
    }
    if(day < 10) {
      day = "0" + day;
    }
    time = year + "-" + month + "-" + day;
    date = day + "/" + month + "/" + year;
    longMonth = a.toLocaleString('en-us', { month: 'long' }); 
    const __date = new Date(year, month-1, day);
    setFullTime(day + " " + __date.toLocaleString('en-us', { month: 'long' }) + " " + year);
    shortMonth = a.toLocaleString('en-us', { month: 'short' });
    setShortFullTime(day + " " + shortMonth + " " + year);
    setTime(time)
  }

  useEffect(() => {
    if(client_name && clients) {

      var userId;
      clients.forEach(element => {
        if(element.name == client_name) {
          userId = element.id;
          setSelectedClientId(element.id);
        }
      });
        //meals 
        getMealplanFromClient(userId, Time, (result) => {
          console.log(Time);
          console.log(result);
          if(result) {

            setTotalMeals(result.plan.length);
            setTotalCalories(result.totalCaloriesAllowed);
            var caloriesDone = 0;
            result.plan.map((item) => {
              item.food.map((item) => {
                if(item.eaten) {
                  caloriesDone = parseInt(caloriesDone) + parseInt(item.calories);
                }
              }) 
            })
            setTotalCaloriesDone(caloriesDone);
          }else {
            setTotalMeals(0);
            setTotalCalories(0);
            setTotalCaloriesDone(0);
          }
        });
        //workouts
        getWorkoutFromClient(userId, Time, (result) => {
          if(result) {
            console.log(result);
            let totalExerciseAmount = 0;
            let totalExercisesDone = 0;
            let totalSecondsExercises = 0;

            result.supersets.map((item) => {
              item.exercises.map((item) => {
                totalExerciseAmount++;
                if(item.completed) {
                  totalExercisesDone++;
                }
                
                // totalSecondsExercises = parseInt(totalSecondsExercises) + (((parseInt(item.up) + parseInt(item.up_pause) + parseInt(item.down_pause) + parseInt(item.down) + parseInt(item.rest_time_in_minutes))* parseInt(item.reps))* parseInt(item.sets)) 
              })
            })
            
            console.log(totalSecondsExercises);

            setTotalExercises(totalExerciseAmount);
            setExercisesDone(totalExercisesDone);
            // setTotalExerciseTime(parseInt(totalSecondsExercises/60).toFixed(0));
          }else {
            setTotalExercises(0);
            setExercisesDone(0);
            setTotalExerciseTime(0);
          }
        });
  }
  }, [client_name, Time, clients])

  function onClick(item) {
    window.location.href=item + "/" + selectedClientId;
  }
 
  return (
    <div className="c-page-wrapper c-page-dashboard">
      <Profile user={user} clientCount={clientCount} workoutCount={workoutCount}></Profile>
      <div className="c-page-wrapper">
        <div className="c-page-main ">
          {/* <Invoices user={user}></Invoices> */}
          <div className="c-page-data-grid">
            <div className="c-page-graph">
              <DropDown options={filterName? filterName : []} value={filter} onChange={(e) => {setFilter(e); setCLientName(e);}} />
              <Graph dayAmount="31" user={user} clientName={client_name} selectedClientId={selectedClientId}></Graph>
            </div>
            <div className="box">
              <div className="c-box-data--row">
                <h3>Mealplan</h3>
                {selectedClientId && <Link className="c-box-data--link"
                  to={{
                    pathname: "clients/" + selectedClientId,
                    state: {clientPage: "Mealplan"}     
                  }}>
                  View Mealplan
                </Link>}
              </div>
              <div className="c-box-data--row">
                <p>Meals</p>
                <p>{totalMeals}</p>
              </div>
              <div className="c-box-data--row">
                <p>Total calories</p>
                <p>{totalCalories}</p>
              </div>
              <div className="c-box-data--row">
                <p>Total calories logged</p>
                <p>{totalCaloriesDone}</p>
              </div>
            </div>
            <div className="box">
              <div className="c-box-data--row">
                <h3>Workout</h3>
                {selectedClientId && <Link className="c-box-data--link"
                  to={{
                    pathname: "clients/" + selectedClientId,
                    state: {clientPage: "Workout"}     
                  }}>
                  View Workout
                </Link>}
              </div>
              <div className="c-box-data--row">
                <p>Total exercises planned</p>
                <p>{totalExercises}</p>
              </div>
              <div className="c-box-data--row">
                <p>Completed exercises</p>
                <p>{exercisesDone}</p>
              </div>
              <div className="c-box-data--row">
                {/* <p>Total time of workout</p>
                <p>{totalExerciseTime}m</p> */}
              </div>
            </div>
          </div>
          
        </div>
        <div className="c-page-side c-page-side-offset">
          <div className="c-dashboard-calender-wrapper">
            <CalendarItem onCalendarChange={handleCalendarChange} />
            <TodoList Time={Time} fulltime={fullTime} shortFulltime={shortFullTime} />


            {/*<CalendarDatePicker onCalendarChange={handleCalendarChange}></CalendarDatePicker>*/}
         </div>
          {/*<div className="c-appointment-list">
            <h2 className="c-appointmet-title">{fullTime}</h2>
            <Appointment user={user} time={Time} currentTime={currentTime}></Appointment>    
            <NavButton text="View Agenda" icon="chevron-right" coloricon="#443712" size={25} onClick={() => onClick('clients')}/>
          </div>*/}
        </div>
      </div>
      <div className="c-log-out" onClick={() => handleLogout()}>
        <Icon icon="log-out" size={20} stroke="#fff" />
      </div>
    </div>
  );
}

export default Dashboard;
